import { useStandardsModalContext } from "@/search/NewSearchPageMVP/provider/StandardsModalProvider";
import { useStandardsSearchContext } from "@/search/NewSearchPageMVP/provider/StandardsSearchProvider";
import { STANDARDS_SET_MODE } from "@/search/NewSearchPageMVP/types/IStandardsSetMode";
import { NoStandardsFound } from "../NoStandardsFound";
import {
  StandardsModalCheckbox,
  StandardsModalViewMoreButton,
} from "../../shared";
import { StandardItem } from "./StandardItem";
import { standardsContainerCss } from "./StandardsList.styles";

export const StandardsList = () => {
  const {
    getters: { filteredStandards, standardsSetMode },
  } = useStandardsModalContext();

  const { currentNeedle, showViewMoreButton } = useStandardsSearchContext();

  const renderStandardsListItems = () => {
    const isViewMode = standardsSetMode === STANDARDS_SET_MODE.VIEW;

    return (
      <ul css={standardsContainerCss}>
        {filteredStandards.map((standard) =>
          isViewMode ? (
            <StandardsModalCheckbox
              key={standard.content_id}
              standard={standard}
            />
          ) : (
            <StandardItem key={standard.content_id} standard={standard} />
          ),
        )}
      </ul>
    );
  };

  return (
    <>
      {renderStandardsListItems()}
      {filteredStandards.length === 0 && currentNeedle !== "" && (
        <NoStandardsFound />
      )}
      {showViewMoreButton ? <StandardsModalViewMoreButton /> : null}
    </>
  );
};
